import { render, staticRenderFns } from "./PublicGLA.vue?vue&type=template&id=3462faf4&scoped=true&"
import script from "./PublicGLA.vue?vue&type=script&lang=js&"
export * from "./PublicGLA.vue?vue&type=script&lang=js&"
import style0 from "./PublicGLA.vue?vue&type=style&index=0&id=3462faf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3462faf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
